import { render, staticRenderFns } from "./ManualCard.vue?vue&type=template&id=7c4c1f5c"
import script from "./ManualCard.vue?vue&type=script&lang=js"
export * from "./ManualCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports